import { Box } from "@material-ui/core";
import styled from "styled-components";

const BoxError = styled(Box)`
  color: ${({ theme }) => theme.palette.error.main};
`;

export default BoxError;
